import React, { useContext, useEffect, useState } from "react";
import { Formik, Form } from "formik";
import { mint } from "../../services/utilService";
import web3 from "web3";
import { KeyNote, KeyScale, KeyScaleMap, KeyNoteMap } from "../../proto/api_pb";
import { toast } from "react-toastify";
import { styles } from "./styles";
import { Collaborator, MintDTO, NFT_VALIDATION_SCHEMA } from "./types";
import Mixpanel from "../../utils/mixpanel";
import {
  AuthContext,
  AuthContextInterface,
  S3CredentialsContext,
  S3CredentialsContextInterface,
} from "../../contexts";
import { UserDetailsContext } from "../../contexts";
import { UserDetailsContextInterface } from "../../contexts";
import { useLocation, useNavigate } from "react-router-dom";
import { awaitableUploadToS3 } from "../../utils/S3Utils";
import UserStatusModal from "../../components/Modal/UserStatusModal";
import { MintKeys } from "../../components/MintComponents/MintKeys";
import { MintManageCreators } from "../../components/MintComponents/MintManageCreators";
import { MintPageModalGroup } from "../../components/MintComponents/MintPageModalGroup";
import { MintTermsAndConditions } from "../../components/MintComponents/MintTermsAndConditions";
import { MintSongDetails } from "../../components/MintComponents/MintSongDetails";
import { MintAddCollabModal } from "../../components/MintComponents/MintAddCollabModal";
import { MintUploadArtWork } from "../../components/MintComponents/MintUploadArtWork";
import { MintUploadAudio } from "../../components/MintComponents/MintUploadAudio";
import useGetValidAccessToken from "../../hooks/useGetValidAccessToken";
import { APP_BACKGROUND_COLOR, TEXT_COLOR } from "../../theme";
const ASSETS_URL = process.env.REACT_APP_ASSET_S3_BUCKET_URL!;
const OMMUSE_SHARE = 0;

const Mint: React.FC<{ userVerified: boolean }> = ({ userVerified }) => {
  const navigate = useNavigate();
  const { getValidAccessToken } = useGetValidAccessToken();
  const [mintResponse, setMintResponse] = useState(undefined);
  const [ownerShare, setOwnerShare] = useState(100);
  const [collaborators, setCollaborators] = useState<Array<Collaborator>>([]);
  const [genres, setGenres] = useState<Array<string>>([]);
  const [collabVal, setCollabVal] = useState("");
  const { allUsers } = useContext(UserDetailsContext);
  const [usersList, setUsersList] = useState<Array<string>>([]);
  const [isChecked, setIsChecked] = useState(false);
  const [previewUrl, setPreviewUrl] = useState("");
  const [isWalletLoading, setIsWalletLoading] = useState(true);
  const [key, setKey] = useState("");
  const [scale, setScale] = useState("");
  const [showWalletTooltip, setShowWalletTooltip] = useState(false);
  const [showBpmTooltip, setShowBpmTooltip] = useState(false);
  const [showKeyTooltip, setShowKeyTooltip] = useState(false);
  const [showPriceTooltip, setShowPriceTooltip] = useState(false);
  const [showCollabTooltip, setShowCollabTooltip] = useState(false);
  const [songChanged, setSongChanged] = useState(false);
  const [imageChanged, setImageChanged] = useState(false);
  const [prevCollabs, setPrevCollabs] = useState<Collaborator[]>([]);
  const { userId } = useContext<AuthContextInterface>(AuthContext);
  const { userName, connectedWallet } =
    useContext<UserDetailsContextInterface>(UserDetailsContext);
  const { awsAccessKeyId, awsSecretAccessKey, awsSessionToken } =
    useContext<S3CredentialsContextInterface>(S3CredentialsContext);
  const location = useLocation();
  const trackArtist: string = location.state?.tarckArtist;
  const trackTitle: string = location.state?.trackTitle;
  const trackBpm: number = location.state?.trackBpm;
  const trackGenre: string = location.state?.trackGenre;
  const trackDescription: string = location.state?.trackDescription;
  const trackImageUrl: string = location.state?.trackImageUrl;
  const trackUrl: string = location.state?.trackUrl;
  const trackKey: string = location.state?.trackKey;
  const trackId: string = location.state?.trackId;
  const trackKeyScale: KeyScaleMap[keyof KeyScaleMap] =
    location.state?.trackKeyScale;
  const trackKeyNote: KeyNoteMap[keyof KeyNoteMap] =
    location.state?.trackKeyNote;
  const trackContributers: string[] = location.state?.trackContributers;

  const newNFT = {
    artist: trackArtist ?? "",
    title: trackTitle ?? "",
    description: trackDescription ?? "",
    price: "",
    bpm: trackBpm !== 0 ? trackBpm : 0,
    songUpload: undefined,
    coverArtUpload: trackImageUrl ?? "",
    genres: trackGenre ?? "",
    newCollaborator: {
      username: "",
      share: "",
    },
    key: [],
  };

  const handleShowWalletTooltip = () => {
    setShowWalletTooltip((prev) => !prev);
  };

  const handleShowBpmTooltip = () => {
    setShowBpmTooltip((prev) => !prev);
  };

  const handleShowKeyTooltip = () => {
    setShowKeyTooltip((prev) => !prev);
  };

  const handleShowPriceTooltip = () => {
    setShowPriceTooltip((prev) => !prev);
  };

  const handleShowCollabTooltip = () => {
    setShowCollabTooltip((prev) => !prev);
  };

  const handleSongChanged = () => {
    setSongChanged(true);
  };

  useEffect(() => {
    document.title = "Mint - OmMuse";
  }, []);

  const handleKey = (
    event: React.MouseEvent<HTMLElement>,
    newKey: string | null
  ) => {
    newKey !== null ? setKey(newKey) : setKey("");
  };

  const handleGoToMyNFTS = () => {
    navigate("/my-nfts");
  };

  const handleScale = (
    event: React.MouseEvent<HTMLElement>,
    newScale: string
  ) => {
    newScale !== null ? setScale(newScale) : setScale("");
  };

  const handleFile = (file: any) => {
    setPreviewUrl(URL.createObjectURL(file));
    URL.revokeObjectURL(previewUrl);
  };
  const handleDragOver = (event: any) => {
    event.preventDefault();
  };

  useEffect(() => {
    if (userName) {
      if (trackContributers) {
        const tempList: Collaborator[] = [];
        trackContributers
          .filter((item) => item !== userName)
          .forEach((item) => {
            const n: Collaborator = { username: item, share: "" };
            tempList.push(n);
          });
        setPrevCollabs([...tempList]);
      }
      setGenres([trackGenre ? trackGenre : ""]);
      if (trackKeyScale) {
        const keyDataScale = trackKeyScale;
        if (keyDataScale === KeyScale.KEY_SCALE_MAJOR) setScale("major");
        if (keyDataScale === KeyScale.KEY_SCALE_MINOR) setScale("minor");
      }
      if (trackKey && trackKeyNote === KeyNote.KEY_NOTE_UNDEFINED)
        setKey(trackKey);
      if (trackKey && trackKeyNote === KeyNote.KEY_NOTE_SHARP)
        setKey(`${trackKey}#`);
      if (trackKey && trackKeyNote === KeyNote.KEY_NOTE_FLAT)
        setKey(`${trackKey}b`);
      if (trackImageUrl) setPreviewUrl(trackImageUrl);
    }
  }, [
    trackGenre,
    trackKeyScale,
    trackKeyNote,
    trackKey,
    trackImageUrl,
    trackContributers,
    userName,
  ]);

  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
  };
  let clearAudio: any = null;

  useEffect(() => {
    const userL = allUsers.filter((user) => user.getUsername() !== userName);
    setUsersList(userL.map((user) => user.getUsername()));
  }, [allUsers, userName]);

  useEffect(() => {
    connectedWallet && setIsWalletLoading(false);
  }, [connectedWallet]);

  const resetFiles = () => {
    setPreviewUrl("");
    clearAudio();
  };

  const saveResetAudioAction = (clearAction: any) => {
    clearAudio = clearAction;
  };

  const getSongUrlForMinting = (originalSongUrl: string) => {
    return originalSongUrl;
  };

  const onSubmit = async (
    values: any,
    {
      resetForm,
      setSubmitting,
    }: {
      resetForm: any;
      setSubmitting: any;
    }
  ) => {
    if (connectedWallet && web3.utils.isAddress(connectedWallet)) {
      try {
        let coverArtUrl = previewUrl;
        if (values.coverArtUpload !== undefined && imageChanged === true) {
          const coverArtKey = await awaitableUploadToS3(
            userId,
            values.coverArtUpload,
            `cover-art`,
            values.coverArtUpload!.type,
            awsAccessKeyId,
            awsSecretAccessKey,
            awsSessionToken,
            () => {}
          );
          coverArtUrl = ASSETS_URL + "/" + coverArtKey;
        }
        let songUrl = trackUrl;
        if (songChanged === true) {
          const songKey = await awaitableUploadToS3(
            userId,
            values.songUpload,
            `song`,
            values.songUpload!.type,
            awsAccessKeyId,
            awsSecretAccessKey,
            awsSessionToken,
            () => {}
          );
          songUrl = ASSETS_URL + "/" + songKey;
        }

        const vars: MintDTO = {
          user_id: userId,
          artist: values.artist,
          title: values.title,
          description: values.description,
          genres: genres,
          price: values.price,
          bpm: values.bpm,
          collaborators: collaborators,
          coverArtUrl: coverArtUrl,
          songUrl: getSongUrlForMinting(songUrl),
          key: key === "" && scale === "" ? [] : [key, scale],
          owner: {
            address: connectedWallet,
            share: ownerShare,
          },
          trackId: trackId,
        };
        const response = await mint(vars, await getValidAccessToken());
        if (response.message === "Invalid share distribution") {
          toast.info(response.message);
        }
        setSubmitting(false);
        resetForm();
        resetFiles();
        setGenres([]);
        setScale("");
        setKey("");
        setImageChanged(false);
        setSongChanged(false);
        setOwnerShare(100);
        setCollaborators([]);
        setIsChecked(false);
        setMintResponse(response.data.message);
        Mixpanel.track("publish_nft", {
          num_collaborators: collaborators.length,
        });
      } catch (error) {
        console.log(error);
        setImageChanged(false);
        setSongChanged(false);
        setSubmitting(false);
        alert(error);
      }
    }
  };

  const addCollaborator = (
    newCollaborator: Collaborator,
    setFieldError: (field: string, message: string | undefined) => void
  ) => {
    if (newCollaborator && newCollaborator.username && newCollaborator.share) {
      if (!Number.isInteger(Number(newCollaborator.share))) {
        setFieldError(
          "newCollaborator.share",
          "Split revenue cannot be in decimal"
        );
        return false;
      }
      if (parseFloat(newCollaborator.share) < 0) {
        setFieldError(
          "newCollaborator.share",
          "Split revenue should be a positive number"
        );
        return false;
      } else {
        if (newCollaborator.username === connectedWallet) {
          // TODO: Check if this comparison is correct
          toast.info("Collaborator cannot be the same as the owner.");
        } else if (
          collaborators.find(
            (collaborator) => collaborator.username === newCollaborator.username
          ) === undefined &&
          usersList.includes(newCollaborator.username)
        ) {
          const updatedCollaborators = [...collaborators, newCollaborator];
          const collaboratorsShare = updatedCollaborators.reduce(
            (accumulator, object) => accumulator + parseFloat(object.share),
            0
          );
          if (collaboratorsShare >= 100) {
            setFieldError(
              "newCollaborator.share",
              "Split revenue cannot exceed 100% "
            );
            return false;
          }
          const collaboratorsWithId = updatedCollaborators.map(
            (collaborator) => {
              const id = allUsers
                .find((user) => user.getUsername() === collaborator.username)
                ?.getUserId();
              return { ...collaborator, id };
            }
          );
          setCollaborators(collaboratorsWithId);
          setOwnerShare(100 - OMMUSE_SHARE - collaboratorsShare);

          const newUserList = usersList.filter(
            (user) => user !== newCollaborator.username
          );
          setUsersList([...newUserList]);
          setCollabVal("");
        } else {
          toast.info("Username does not exist");
        }
        return true;
      }
    }
  };

  const removeCollaborator = (collaborator: Collaborator) => {
    let totalShare = 0;

    collaborators.forEach((item) => {
      totalShare += parseInt(item.share);
    });
    const updatedCollaborators = collaborators.filter(
      (item) => item !== collaborator
    );
    setCollaborators(updatedCollaborators);
    const sum = 100 - OMMUSE_SHARE - totalShare + parseInt(collaborator.share);
    setOwnerShare(sum);

    const newUsersList = [...usersList, collaborator.username];
    setUsersList([...newUsersList]);
  };
  return (
    <>
      <UserStatusModal userId={userId} targetPage={"/mint"} />
      <main
        style={{ backgroundColor: APP_BACKGROUND_COLOR, color: TEXT_COLOR }}
        className="main"
      >
        <div
          style={{ backgroundColor: APP_BACKGROUND_COLOR, color: TEXT_COLOR }}
          className="form-container"
        >
          <p style={styles.mintNftTitle}>Mint NFT</p>
          <hr style={{ marginBottom: 30 }} />
          <Formik
            initialValues={newNFT}
            onSubmit={onSubmit}
            validationSchema={NFT_VALIDATION_SCHEMA}
          >
            {({
              values,
              handleChange,
              isSubmitting,
              setFieldValue,
              setFieldError,
              handleBlur,
              errors,
              touched,
            }) => (
              <>
                <MintAddCollabModal
                  prevCollabs={prevCollabs}
                  setPrevCollabs={setPrevCollabs}
                  isSubmitting={isSubmitting}
                  addCollaborator={addCollaborator}
                  setFieldError={setFieldError}
                />
                <Form>
                  <div style={{ color: "white" }} className="form-content">
                    <MintUploadAudio
                      errors={errors}
                      touched={touched}
                      handleBlur={handleBlur}
                      setFieldValue={setFieldValue}
                      isSubmitting={isSubmitting}
                      saveResetAudioAction={saveResetAudioAction}
                      location={location}
                      trackTitle={trackTitle}
                      handleSongChanged={handleSongChanged}
                      trackUrl={trackUrl}
                    />
                    <MintUploadArtWork
                      errors={errors}
                      touched={touched}
                      previewUrl={previewUrl}
                      handleBlur={handleBlur}
                      handleDragOver={handleDragOver}
                      setFieldValue={setFieldValue}
                      handleFile={handleFile}
                      setImageChanged={setImageChanged}
                      isSubmitting={isSubmitting}
                    />
                    <MintSongDetails
                      setShowWalletTooltip={setShowWalletTooltip}
                      showWalletTooltip={showWalletTooltip}
                      handleShowWalletTooltip={handleShowWalletTooltip}
                      connectedWallet={connectedWallet}
                      errors={errors}
                      touched={touched}
                      values={values}
                      handleChange={handleChange}
                      handleBlur={handleBlur}
                      isSubmitting={isSubmitting}
                      genres={genres}
                      setGenres={setGenres}
                      setFieldValue={setFieldValue}
                      setShowBpmTooltip={setShowBpmTooltip}
                      showBpmTooltip={showBpmTooltip}
                      handleShowBpmTooltip={handleShowBpmTooltip}
                    />
                    <MintKeys
                      setShowKeyTooltip={setShowKeyTooltip}
                      showKeyTooltip={showKeyTooltip}
                      handleShowKeyTooltip={handleShowKeyTooltip}
                      key={key}
                      handleKey={handleKey}
                      scale={scale}
                      handleScale={handleScale}
                    />
                    <MintManageCreators
                      errors={errors}
                      touched={touched}
                      setShowPriceTooltip={setShowPriceTooltip}
                      showPriceTooltip={showPriceTooltip}
                      handleShowPriceTooltip={handleShowPriceTooltip}
                      values={values}
                      handleChange={handleChange}
                      handleBlur={handleBlur}
                      isSubmitting={isSubmitting}
                      setShowCollabTooltip={setShowCollabTooltip}
                      showCollabTooltip={showCollabTooltip}
                      handleShowCollabTooltip={handleShowCollabTooltip}
                      ownerShare={ownerShare}
                      userName={userName}
                      collaborators={collaborators}
                      removeCollaborator={removeCollaborator}
                      collabVal={collabVal}
                      setCollabVal={setCollabVal}
                      setFieldValue={setFieldValue}
                      newNFT={newNFT}
                      usersList={usersList}
                      addCollaborator={addCollaborator}
                      setFieldError={setFieldError}
                    />
                    <MintTermsAndConditions
                      isChecked={isChecked}
                      handleCheckboxChange={handleCheckboxChange}
                      isSubmitting={isSubmitting}
                      connectedWallet={connectedWallet}
                    />
                  </div>
                </Form>
              </>
            )}
          </Formik>
          <MintPageModalGroup
            mintResponse={mintResponse}
            setMintResponse={setMintResponse}
            handleGoToMyNFTS={handleGoToMyNFTS}
            isWalletLoading={isWalletLoading}
            connectedWallet={connectedWallet}
          />
        </div>
      </main>
    </>
  );
};

export default Mint;
